import { QueryKeys } from 'types/dev';
import { Translation } from 'types/translation';
import { translationSchema } from 'schemas/translation';
import { useQuery } from '@tanstack/react-query';

async function getTranslation(): Promise<Translation> {
  const result = await fetch(`${process.env.PUBLIC_URL}/config/translation.json`);
  const data = await result.json();
  const parse = translationSchema.safeParse(data);
  if (!parse.success) {
    throw parse.error;
  }
  return parse.data;
}

export default function useTranslation(): Translation | undefined {
  const { data: translation } = useQuery([QueryKeys.TRANSLATION], getTranslation);
  return translation;
}
